import { useSpaceStore } from '@/modules/space/stores/SpaceStore'
import { Route } from 'vue-router'

export function getSpaceIdFromRoute(route: Route): string {
  const pathParts = route.path.split('/')
  const idIndex = ['spaces', 'workspaces', 'verify'].includes(pathParts[1]) ? 2 : 1
  const spaceSlug = pathParts[idIndex]
  return useSpaceStore().getIdFromSpaceSlug(spaceSlug)
}

/**
 * Gets the current spaceId from store or route
 * Tries SpaceStore.currentSpaceId first, then falls back to route
 * Optimized for performance with early returns
 * @param route - Vue router route object (optional, will use current route if not provided)
 * @returns spaceId string or null if not found
 */
export function getCurrentSpaceId(route?: Route): string | null {
  const spaceStore = useSpaceStore()

  // Try store first (fastest path - O(1) lookup)
  const currentSpaceId = spaceStore.currentSpaceId
  if (currentSpaceId) {
    return currentSpaceId
  }

  // Fallback to route only if route is provided
  if (!route) {
    return null
  }

  try {
    return getSpaceIdFromRoute(route)
  } catch (error) {
    // Silently fail - don't log in production to avoid noise
    return null
  }
}
